import React from 'react';
import { Link } from 'react-router-dom';
import { Tag, Calendar, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

// Static promotions data
const promotions = [
  {
    id: 'promo-1',
    title: '20% OFF Banners & Signs',
    description: 'Get 20% off all banner and sign orders through March 31, 2026',
    code: 'BANNER20',
    expiryDate: '2026-03-31',
    image: 'https://images.unsplash.com/photo-1626785774573-4b799315345d?w=800&q=80'
  },
  {
    id: 'promo-2',
    title: 'Volume Discounts on Business Cards',
    description: 'Order 5000+ business cards and save up to 30%',
    code: 'VOLUME30',
    expiryDate: '2026-12-31',
    image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&q=80'
  }
];

const PromotionsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-br from-blue-600 to-blue-800 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <Tag className="w-4 h-4" />
            Current Offers
          </div>
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Special Promotions</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            Save big on our premium printing services with exclusive discounts
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-6xl mx-auto space-y-8">
          {promotions.map((promo) => (
            <Card key={promo.id} className="overflow-hidden border-2 hover:border-blue-600 hover:shadow-xl transition-all">
              <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="aspect-[16/10] md:aspect-auto overflow-hidden">
                  <img
                    src={promo.image}
                    alt={promo.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <CardContent className="p-8 flex flex-col justify-center">
                  <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-semibold mb-4 w-fit">
                    <Tag className="w-4 h-4" />
                    Active Promotion
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-4">{promo.title}</h2>
                  <p className="text-gray-600 text-lg mb-6 leading-relaxed">{promo.description}</p>
                  
                  <div className="space-y-4">
                    <div className="flex items-center gap-3">
                      <div className="bg-blue-600 text-white px-6 py-3 rounded-lg font-mono font-bold text-lg">
                        {promo.code}
                      </div>
                      <span className="text-gray-600">Use this code at checkout</span>
                    </div>
                    
                    <div className="flex items-center gap-2 text-gray-600">
                      <Calendar className="w-5 h-5" />
                      <span>Valid until {new Date(promo.expiryDate).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</span>
                    </div>
                  </div>

                  <Button size="lg" className="mt-6 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800" asChild>
                    <Link to="/products">
                      Shop Now
                      <ArrowRight className="ml-2 w-5 h-5" />
                    </Link>
                  </Button>
                </CardContent>
              </div>
            </Card>
          ))}
        </div>

        {/* Additional Info */}
        <Card className="mt-12 max-w-4xl mx-auto bg-gradient-to-br from-blue-50 to-white border-2 border-blue-200">
          <CardContent className="p-8 text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Want More Exclusive Offers?</h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Subscribe to our newsletter to receive the latest promotions, new product launches, and special pricing directly to your inbox.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
              />
              <Button size="lg" className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 whitespace-nowrap">
                Subscribe
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PromotionsPage;
